export default __webpack_public_path__ + "static/media/cups.d013bf7f.jpeg";